import { componentsTranslation } from '@/assets/locales/components/components.translation.en.ts';
import { dictionariesTranslation } from '@/assets/locales/dictionaries/dictionaries.translations.en.ts';
import { errorsTranslation } from '@/assets/locales/errors/errors.translation.en.ts';
import { generalErrorTranslation } from '@/assets/locales/generalError/generalError.translation.en.ts';
import { menuTranslation } from '@/assets/locales/menu/menu.translation.en.ts';
import { pageTitlesTranslation } from '@/assets/locales/pageTitles/pageTitles.translation.en.ts';
import { I18N_NAMESPACE, Translations } from '@/assets/locales/pl.ts';
import { topBarTranslation } from '@/assets/locales/topBar/topBar.translation.en.ts';
import { utilsTranslation } from '@/assets/locales/util/utils.translation.en.ts';
import { validationTranslation } from '@/assets/locales/validation/validation.translation.en.ts';

import { viewsTranslation } from './views/views.translation.en.ts';

export const en: Translations = {
  [I18N_NAMESPACE]: {
    components: componentsTranslation,
    dictionaries: dictionariesTranslation,
    errors: errorsTranslation,
    generalError: generalErrorTranslation,
    menu: menuTranslation,
    pageTitles: pageTitlesTranslation,
    topBar: topBarTranslation,
    utils: utilsTranslation,
    validation: validationTranslation,
    views: viewsTranslation,
  },
};
